// Dependencies
import React, { Component } from 'react';
import { isMobileOnly } from 'react-device-detect';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Security
import { authenticationChecker } from '../../components/security/authentication-checker';

// Redux
import { connect } from 'react-redux';

class SitePage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true
        };
    }

    render() {
       return (
                <div>
                    {
                        this.state.loading ?
                            <div className='container'>
                                <div className="col-12 t-align-center">
                                    <i className="mgt-100 mgb-100 pi pi-spin pi-spinner" style={{ fontSize: '4rem', color: '#0073aa' }}></i>
                                </div>
                            </div>
                            : null
                    }

                    <div className={isMobileOnly ? 'grid mgb-20' : 'grid mgb-80'}>
                        <div className='col-12'>
                        <iframe style={{width:"100vw", height:"100vh", border:"none", display:"block"}} src={this.props.url} onLoad={() => this.setState({loading: false})}></iframe>
                        </div>
                    </div>  
                </div>
            );
    }
}

const mapStateToProps = (state) => {
    return {
        url: state.app.url,
        language: state.profile.language
    } 
};

export default connect(mapStateToProps, undefined)(withTranslation(SitePage)); // authenticationChecker